import React from 'react';
import Icon from './Icon';

const ListIcon = (props) => (
    <Icon {...props}>
        <path
            d="M8 6H20M8 12H17M8 18H14M4 6H4.01M4 12H4.01M4 18H4.01"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default ListIcon;